import DetailService from '../../components/DetailService';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

function DeveloppementWeb() {
    return (
        <div className="dark:bg-fond-sombre">
            <Header/>
        <DetailService
            titre="Développement de sites web, d'applications mobiles et de logiciels"
            categorie="Ingénierie"
            image="/images/ingenierie.avif"
            description="Chez i2c, nous créons des sites web modernes, adaptés à tous les écrans et optimisés pour une navigation fluide. Chaque projet est conçu sur mesure avec des fonctionnalités interactives répondant aux besoins spécifiques de nos clients. Nos intervenants développent également des applications mobiles pour iOS, Android et le web. Grâce à une formation axée sur la pratique, nos intervenants acquièrent une expertise solide à travers divers projets et cours. Enfin, nous réalisons des logiciels sur mesure en utilisant des technologies adaptées à vos besoins. Nos solutions s’intègrent facilement à vos systèmes existants."
            etapes={[
                {
                    numero: 1,
                    titre: 'Cadrage du besoin client',
                    texte: 'Rencontre avec le client pour identifier ses objectifs, ses contraintes techniques et fonctionnelles, et définir le périmètre exact du projet. Cette étape sert de référence tout au long du développement.',
                },
                {
                    numero: 2,
                    titre: 'Maquettage des pages',
                    texte: 'Conception des wireframes et maquettes graphiques des interfaces principales. Le client valide les choix UX/UI avant tout développement, ce qui limite les allers-retours en phase de production.',
                },
                {
                    numero: 3,
                    titre: 'Développement du site ou de l\'application',
                    texte: 'Implémentation technique de la solution selon les maquettes validées, avec des points de convergence réguliers et des comptes-rendus hebdomadaires pour assurer le suivi du projet.',
                },
                {
                    numero: 4,
                    titre: 'Tests et recette',
                    texte: 'Phase de tests fonctionnels, de compatibilité et d\'ergonomie pour s\'assurer que la solution répond aux exigences définies. Les retours du client sont intégrés avant la livraison finale.',
                },
                {
                    numero: 5,
                    titre: 'Déploiement et livraison',
                    texte: 'Mise en ligne ou livraison de la solution, accompagnée d\'une documentation technique. Des opérations de maintenance et de mise à jour peuvent être prévues selon le contrat.',
                },
            ]}
            realisations={[
                // {
                //     image: '/images/b2b.avif',
                //     titre: 'Développement d\'une application marketplace ',
                //     tag: 'Développement mobile/web',
                //     description: 'Développement d’une application marketplace B2B permettant aux artisans de créer leur marque, personnaliser des produits fournis par des partenaires et gérer leurs commandes depuis mobile ou web.',
                // },
                // {
                //     image: '/images/GeoCanalMidi.avif',
                //     titre: 'Géo Canal Midi',
                //     tag: 'Développeemnt mobile',
                //     description: 'développement de l\'application Géo Canal du Midi, permettant aux touristes d\'explorer le patrimoine culturel et géographique du Canal du Midi.',
                // },
            ]}
        />
        <Footer/>
        </div>
    );
}
export default DeveloppementWeb;
